import CustomFormWriteModal from "@cc/modules/crm/custom-forms/CustomFormWriteModal.vue";

export default {
    data() {
        return {
            defaultWriteForm: null
        }
    },
    methods: {
        openDefaultWriteForm(formProps={}){
          this.$modal.show(
              CustomFormWriteModal,
              {
                  form: this.defaultWriteForm,
                  ...formProps,
              },
              {
                  height: "auto",
                  scrollable: true
              }
          );
        },
        fetchDefaultWriteForm(resource, args= null){
          axios
              .get(this.genUrl('form_layout'), {params: {'default_form': resource}})
              .then(({data}) => {
                  if(data.data.length){
                      this.defaultWriteForm = data.data[0];
                  }else{
                      alert('No default create form defined!')
                  }
                  if(data.data.length > 1){
                      alert('Multiple default create forms defined!')
                  }
                  if(this.defaultWriteForm && args?.openNow){
                      const _props = args.props ? args.props : {}
                      this.openDefaultWriteForm(_props)
                  }
              })
              .catch((err) => {
                  console.error(err);
                    alert('FORM_WRITE_FETCH_ERROR')
              });
        },
    }
}